import LavaScale from "./components/lava-scale";
import LavaMap from "./components/lava-map";
import LavaUpload from "./components/lava-upload";

import Reveal from "./features/reveal";
import Hero from "./features/hero";
import LavaAccordion from "./features/accordion";
import Quotes from "./features/quotes";
new Reveal('.js--reveal');
new Hero();
new LavaAccordion('.js--accordion');
new Quotes('.js--quotes');

document.documentElement.classList.replace('no-js', 'js');
document.body.classList.replace('opacity-0', 'opacity-100');
